import React from "react";
import { Link } from "react-router-dom";

export default function Header() {
  const sideMenu = () => {
    // if (document.body.classList.contains("menu-show")) {
    //   document.body.classList.remove("menu-show");
    // } else {
    //   document.body.classList.add("menu-show");
    // }
  };
  return (
    <>
      <div className="container-fluid px-0">
        <div className="header-section d-flex align-items-center ">
          <div className="header-logo d-flex align-items-center justify-content-center">
            <Link to="/">
            <img
              className="img-fluid"
              src='../../../assets/images/amc_logo.svg'
              alt="logo-img"
            />
            </Link>
          </div>

          <nav className="navbar navbar-expand-lg ms-auto d-xl-none">
        <div className="container-fluid">
          <button className="navbar-toggler ms-auto" onClick={()=> sideMenu()} type="button" data-bs-toggle="collapse" data-bs-target="#collapsibleNavbar">
            <span className="navbar-toggler-icon" />
          </button>
          <div className="collapse header-collapse navbar-collapse" id="collapsibleNavbar">
          <div className="d-flex header-title align-items-center justify-content-between">
            <p className="mb-0 font-medium">RTM Portal</p>

            <ul className="d-flex align-items-center">
              <li className="d-flex align-items-center notification-bage-col">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M19 8.75C16.93 8.75 15.25 7.07 15.25 5C15.25 2.93 16.93 1.25 19 1.25C21.07 1.25 22.75 2.93 22.75 5C22.75 7.07 21.07 8.75 19 8.75ZM19 2.75C17.76 2.75 16.75 3.76 16.75 5C16.75 6.24 17.76 7.25 19 7.25C20.24 7.25 21.25 6.24 21.25 5C21.25 3.76 20.24 2.75 19 2.75Z"
                    fill="#020617"
                  />
                  <path
                    d="M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C12.73 1.25 13.46 1.32 14.17 1.47C14.58 1.55 14.84 1.95 14.75 2.36C14.67 2.77 14.27 3.03 13.87 2.94C13.26 2.81 12.63 2.75 12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 11.38 21.19 10.76 21.07 10.16C20.99 9.75 21.25 9.36 21.66 9.28C22.07 9.19 22.46 9.46 22.54 9.87C22.68 10.57 22.75 11.29 22.75 12.01C22.75 17.93 17.93 22.75 12 22.75Z"
                    fill="#020617"
                  />
                </svg>

                <span className="notification-badge d-flex align-items-center justify-content-center rounded-circle ">2</span>
              </li>
<li></li>
              <li className="user-img-col">
                <div className="dropdown">
                  <span
                    type="button"
                    className="dropdown-toggle d-flex align-items-center  "
                    data-bs-toggle="dropdown"
                  >
                    <img className="img-fluid" src="../../../assets/images/dummy-img.svg" alt="profile-img"/>
                    <div className="user-name text-start d-flex flex-column ">
                    <p className="mb-0">Booguu Co. Ltd.</p>
                    <span className="block slate-500">Gordon L.</span>
                    </div>
                   
                  </span>
                  <ul className="dropdown-menu">
                    <li>
                      <Link className="dropdown-item" to="#">
                        Logout
                      </Link>
                    </li>
                    
                  </ul>
                </div>
              </li>
            </ul>
          </div>
          </div>
        </div>
      </nav>
      
          <div className="d-xl-flex d-none header-title align-items-center justify-content-between">
            <p className="mb-0 font-medium">RTM Portal</p>

            <ul className="d-flex align-items-center">
              <li className="d-flex align-items-center notification-bage-col">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M19 8.75C16.93 8.75 15.25 7.07 15.25 5C15.25 2.93 16.93 1.25 19 1.25C21.07 1.25 22.75 2.93 22.75 5C22.75 7.07 21.07 8.75 19 8.75ZM19 2.75C17.76 2.75 16.75 3.76 16.75 5C16.75 6.24 17.76 7.25 19 7.25C20.24 7.25 21.25 6.24 21.25 5C21.25 3.76 20.24 2.75 19 2.75Z"
                    fill="#020617"
                  />
                  <path
                    d="M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C12.73 1.25 13.46 1.32 14.17 1.47C14.58 1.55 14.84 1.95 14.75 2.36C14.67 2.77 14.27 3.03 13.87 2.94C13.26 2.81 12.63 2.75 12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 11.38 21.19 10.76 21.07 10.16C20.99 9.75 21.25 9.36 21.66 9.28C22.07 9.19 22.46 9.46 22.54 9.87C22.68 10.57 22.75 11.29 22.75 12.01C22.75 17.93 17.93 22.75 12 22.75Z"
                    fill="#020617"
                  />
                </svg>

              </li>
<li></li>
              <li className="user-img-col">
                <div className="dropdown">
                  <span
                    type="button"
                    className="dropdown-toggle d-flex align-items-center  "
                    data-bs-toggle="dropdown"
                  >
                    <img className="img-fluid" src="../../../assets/images/booguu_logo_newBlue.png" 
                    width={40} height={40} alt="profile-img"/>
                    <div className="user-name text-start d-flex flex-column ">
                    <p className="mb-0">Booguu Co. Ltd.</p>
                    <span className="block slate-500">Gordon L.</span>
                    </div>
                   
                  </span>
                  <ul className="dropdown-menu">
                    <li>
                      <Link className="dropdown-item" to="#">
                        Logout
                      </Link>
                    </li>
                    
                  </ul>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}
